import { Typography, Button } from "../../components"
import "./styles.css";

export default function SteunverklaringSubsidieverzoek(props) {
    return (
        <div className="container">
            <iframe
                title="Steunverklaring subsidieverzoek NOLIA BabyFeeding"
                src="https://app.enormail.eu/subscribe/3ed43ae9681a9fffe5e5f9a0bf1ee83c"
                style={{
                width: "100%",
                height: "100vh",
                border: "none"
                }}
                allow="fullscreen; payment"
            ></iframe>
        </div>
    )
}